import { render, staticRenderFns } from "./SystemConfigSpread.vue?vue&type=template&id=5a8b0f7b&"
import script from "./SystemConfigSpread.vue?vue&type=script&lang=js&"
export * from "./SystemConfigSpread.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigSpread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports